import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { CheckBoxCustomization } from './checkbox-edit';

@Component({
  selector: 'lib-checkbox-compiled',
  imports: [ReactiveFormsModule, CheckboxModule],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="flex-column w-5/5 flex" (keydown)="onKeyDown($event)">
        <label for="data" class="break-all">{{
          widget.customization.description
        }}</label>
        <p-checkbox
          id="data"
          [value]="widget.customization.description"
          [binary]="true"
          [formControl]="formControl"
        />
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class CheckBoxCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<CheckBoxCustomization>,
  );

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
